import React, { useState } from 'react';
import './Disclaimer.css';
import Button from '@mui/material/Button';
import {DoneAllSharp} from "@mui/icons-material";
import {Modal, Tooltip} from "antd";
import {CloseOutlined} from "@ant-design/icons"; // Assuming you have a separate CSS file for styles
import {PLATFORM_AGREEMENT_DISCLAIMER} from "../../configs/disclaimerTextConfig";


const Disclaimer = ({ text=PLATFORM_AGREEMENT_DISCLAIMER }) => {
    const [visible, setVisible] = useState(false);

    return (
        <>
            <Tooltip title={'Click to Expand'}>
                <div className="disclaimer cursor" onClick={()=>setVisible(true)}>
                  <div className="inner" dangerouslySetInnerHTML={{ __html: text }} />
                </div>
            </Tooltip>
            <Modal
                title="Disclaimer"
                open={visible}
                onCancel={() => setVisible(false)}
                footer={[
                    <Button startIcon={<DoneAllSharp/>} color={'primary'} size={'large'} key="agree" onClick={() => setVisible(false)}>
                        I Agree
                    </Button>
                ]}
            >
                <div className={'p-3 disclaimer long'} dangerouslySetInnerHTML={{__html: text}}></div>
            </Modal>
        </>
    );
};

export default Disclaimer;
